import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MasterDetailModule } from '@sdbn/common';
import { SmartphoneComponent } from './component/smartphone.component';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { EquipmentLogModule } from '@sdbn/tmc-common';

@NgModule({
  declarations: [
    SmartphoneComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    EquipmentLogModule,
    MasterDetailModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule
  ],

})
export class SmartphoneModule { }

